<template>
  <div v-if="!pageReady">
    <b-spinner label="Loading"></b-spinner>
  </div>

  <div v-else class="payments-container">
    <b-alert
      :show="Boolean(pageMessage.length > 0)"
      :variant="pageMessageVariant"
      id="pricing-alert"
    >
      {{ pageMessage }}
    </b-alert>

    <br />
    <br />
    <br />

    <div class="payments">
      <PaymentCard
        @purchase-credits="purchaseCreditsHandler"
        v-for="payment in payments"
        v-bind:key="payment.UUID"
        :credits="payment.credits"
        :description="payment.description"
        :imageSource="payment.imageSource"
        :modal="payment.modal"
        :price="payment.price"
        :title="payment.title"
        :UUID="payment.UUID"
      />
    </div>

    <br />
    <br />
    <br />

    <div>
      <a href="https://teleportal.net/product/gift-card/" target="_blank">
        <img
          class="gift"
          src="https://teleportal-files.s3-ap-southeast-2.amazonaws.com/gift.png"
        />
      </a>
      <a
        href="https://teleportal.net/product/educational-private-session/"
        target="_blank"
      >
        <img
          class="gift"
          src="https://teleportal-files.s3-ap-southeast-2.amazonaws.com/education.png"
        />
      </a>
      <a
        href="https://teleportal.net/corporate-booking/"
        target="_blank"
      >
        <img
          class="gift"
          src="https://teleportal-files.s3-ap-southeast-2.amazonaws.com/corporate.png"
        />
      </a>
    </div>

    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div>
      <a href="https://stripe.com/en-ca">
        <img
          class="stripe-logo"
          src="@/assets/secure-stripe-payment-logo.svg"
        />
      </a>
    </div>

    <div>
      <img class="stripe-accepted-cards" src="@/assets/mastercard.png" />
      <img class="stripe-accepted-cards" src="@/assets/visa.svg" />
      <img class="stripe-accepted-cards" src="@/assets/discover.png" />
    </div>

    <div>
      <h5><i>At Teleportal, we offer a range of robotic services tailored to meet your specific needs.</i></h5>
      <h5><i>Our pricing structure is based on which robot you choose to control, with an average hourly cost ranging from $20 to $50 Australian Dollars.</i></h5>
      <h5><i>To ensure a transparent and flexible billing process, we calculate all charges on a per-minute basis, and all fees are quoted in Australian Dollars.</i></h5>
    </div>
  </div>
</template>

<script>
import PaymentCard from "@/components/PaymentCard.vue";
import StripeActions from "@/services/api/controllers/stripe";
import Users from "@/services/api/controllers/users";

export default {
  components: {
    PaymentCard
  },

  data: function() {
    return {
      pageMessage: "",

      pageMessageVariant: "",

      pageReady: true,

      payments: [
        {
          credits: 60,
          description:
            "The easiest way to get started! This package is for all those guppies who are just learning how to swim and like the shallow end of the pool.",
          imageSource:
            "https://teleportal-files.s3-ap-southeast-2.amazonaws.com/payment-starter.png",
          modal: "starter-package",
          price: 9.9,
          title: "Starter Package",
          UUID: "8034bb9a-60ee-42c1-a70e-b530ff7e7ad1"
        },

        {
          credits: 200,
          description:
            "This is our most popular package. It provides great value for money at one low price for all types of users from casual to the more advanced.",
          imageSource:
            "https://teleportal-files.s3-ap-southeast-2.amazonaws.com/payment-premium.png",
          modal: "premium-package",
          price: 29.9,
          title: "Premium Package",
          UUID: "66000080-1ad3-4ac6-9f53-964c6d2c1424"
        },

        {
          credits: 500,
          description:
            "A package designed for serious gamers. You will get many hours of live robot action for the same price you would normally spend on other games.",
          imageSource:
            "https://teleportal-files.s3-ap-southeast-2.amazonaws.com/payment-gamer.png",
          modal: "gamer-package",
          price: 69.42,
          title: "Gaming Package",
          UUID: "5c65c9ed-9503-4f2d-922d-604a13c73963"
        },

        {
          credits: 1000,
          description:
            "Do you want to support Teleportal? This is the package for you. Help us add more robots to the fleet quickly by purchasing our Partner Package.",
          imageSource:
            "https://teleportal-files.s3-ap-southeast-2.amazonaws.com/payment-partner.png",
          modal: "partner-package",
          price: 129.9,
          title: "Partner Package",
          UUID: "0442c442-f32f-4717-8ec2-923177a79035"
        }
      ]
    };
  },

  methods: {
    purchaseCreditsHandler: async function({ packageName, error }) {
      try {
        this.pageReady = false;
        if (error) {
          this.pageMessage = `${error}`;
          this.pageMessageVariant = "warning";

          // Renders are asynchronous in Vue.js, need to wait till the alert element is drawn
          this.$nextTick(() =>
            document
              .getElementById("pricing-alert")
              .scrollIntoView({ behavior: "smooth" })
          );
        } else {
          // Redirect to stripe checkouts in the event a user wants to buy tokens
          const accessToken = await this.$auth.getTokenSilently();
          const checkout = await StripeActions.createCheckoutSession(
            packageName,
            accessToken
          );

          return this.stripe.redirectToCheckout({
            sessionId: checkout.id
          });
        }
      } catch (error) {
        this.pageMessage = `Failed to load Stripe Checkout. Please contact support ${error}`;
        this.pageMessageVariant = "danger";

        // Renders are asynchronous in Vue.js, need to wait till the alert element is drawn
        this.$nextTick(() =>
          document
            .getElementById("pricing-alert")
            .scrollIntoView({ behavior: "smooth" })
        );
        this.pageReady = true;
      }
    }
  },

  mounted: function() {
    try {
      this.pageReady = false;
      // Create our Stripe Object that connects with our instance of stripe via our publishable key
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

      return;
    } catch (error) {
      this.pageMessage = `Failed to mount in Pricing. Please contact support ${error}`;
      this.pageMessageVariant = "danger";
    } finally {
      this.pageReady = true;
    }
  }
};
</script>

<style scoped>
.payments-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-content: center;
}

.gift {
  height: 15vw;
  margin: 0.5vw;
  margin-bottom: 5rem;
}

.stripe-logo {
  height: 4.5vh;
  margin: 0.5vw;
}

.footer {
  background-color: royalblue;
  color: white;
  text-align: center;
}

.footer a {
  color: white;
  text-align: center;
}

.footer a:hover {
  color: white;
  text-decoration: underline;
}

a {
  color: #42b983;
}

a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.stripe-accepted-cards {
  margin: 0.5vw;
  height: 4vw;
  width: 4vw;
}

.payments {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 5rem;
  margin-top: 3rem;
}

/* Default to four columns on larger screens */
.payments > * {
  flex-basis: calc(100% / 4);
  max-width: calc(100% / 4); /* Ensure the column does not exceed the calculated width */
}

/* Media query for medium screens (e.g., tablets) */
@media (max-width: 1200px) {

  .payments > * {
    flex-basis: calc(100% / 2);
    max-width: calc(100% / 2); /* Two columns */
  }

  .gift {
    height: 30vw;
    margin: 0.5vw;
    margin-bottom: 5rem;
  }

}

/* Media query for small screens (e.g., mobile devices) */
@media (max-width: 768px) {

  .payments {
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items */
  }

  .payments > * {
    flex-basis: 100%; /* Each item takes full width of the container */
    max-width: 100%; /* Ensure items don't exceed container width */
    margin: 10px 0; /* Add some vertical margin for spacing */
  }

  .gift {
    height: 50vw;
    margin: 0.5vw;
    margin-bottom: 5rem;
  }

}

</style>